// Lecture d'un code QR par la caméra arrière. La
// bibliothèque est chargée au premier scan, pas avec les pages. `scan` :
// { isCurrent() : la lecture est-elle toujours attendue (page quittée,
// nouveau scan) ; reader : lecteur posé ici, arrêté par stopScan }. Lecture
// abandonnée pendant le chargement : caméra jamais demandée ; après : rendue
// aussitôt ; promesse sans suite.
export async function readQrCode(video, scan) {
    const { BrowserQRCodeReader } = await import('@zxing/library/es2015');
    if (!scan.isCurrent()) return new Promise(() => {});
    const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
    if (!scan.isCurrent()) {
        stream.getTracks().forEach((track) => track.stop());
        return new Promise(() => {});
    }
    scan.reader = new BrowserQRCodeReader();
    const result = await scan.reader.decodeOnceFromStream(stream, video);
    return result.text;
}

// Lecture arrêtée : décodage et caméra.
export function stopScan(scan, video) {
    try { scan?.reader?.reset(); } catch (error) { /* lecteur déjà arrêté */ }
    const stream = video.srcObject;
    if (stream) stream.getTracks().forEach((track) => track.stop());
    video.srcObject = null;
}
